module.exports = __webpack_public_path__ + "e80a3ae3a63bbafac85addd03b89b06d.pdf";